/** @jsx jsx */

import React, { Fragment as _ } from 'react';
import { keyframes } from 'emotion';
import { css, jsx } from '@emotion/core';
import EditMarker from 'components/UI/EditMarker';
import setCurrentBlock from 'services/apiHelpers/setCurrentBlock';
import { colors } from 'styles/variables';
import embedIcon from 'assets/Embed.svg';

const { lPink } = colors;

const frameSelected = keyframes`
  from {
    width: 50%;
    height: 50%;
  }
  to {
    width: 75%;
    height: 75%;
  }
`;

const frameNotSelected = keyframes`
from {
  width: 75%;
  height: 75%;
}
to {
  width: 50%;
  height: 50%;
}
`;

const EditWrapper0 = ({ id, mediaParentId, selected, children }) => {
  return (
    <div
      css={css`
        position: relative;
        width: 100%;
        height: 100%;
        box-shadow: ${selected ? `0 0 0 1px ${lPink}` : '0 0 0 1px lightGrey'};
        transition: box-shadow 0.2s;
        cursor: pointer;

        &:hover {
          ${!selected && `box-shadow: 0 0 0 1px ${lPink};`}
        }

        * {
          pointer-events: ${selected ? 'auto' : 'none'};
        }

        @media (max-width: 768px) {
          padding: 5px;
        }
      `}
      onClick={e => {
        e.stopPropagation();

        if (selected) return;

        // console.log({ mediaParentId });

        setCurrentBlock({ id });
      }}
    >
      {children}

      {!selected && <EditMarker />}
    </div>
  );
};

// ${!selected && 'border-radius:  50%;'}
const EditWrapper1 = ({ id, mediaParentId, selected, children }) => {
  return (
    <div
      css={css`
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
      `}
    >
      {children}
      <div
        css={css`
          position: absolute;
          display: flex;
          justify-content: center;
          align-items: center;
          left: 0px;
          top: 0px;
          width: 100%;
          height: 100%;
        `}
      >
        <div
          css={css`
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          width: ${selected ? '75%' : '50%'};
          height: ${selected ? '75%' : '50%'};

          ${selected && `animation: ${frameSelected} 0.2s forwards;`}
        
          ${!selected &&
            `
          background: rgba(0, 0, 0, 0.1);
        `}
          
          box-shadow: ${
            selected ? `0 0 0 1px ${lPink}` : '0 0 0 1px lightGrey'
          };
          transition: all 0.2s;
          cursor: pointer;
          &:hover {
            ${!selected && `box-shadow: 0 0 0 1px ${lPink};`}
          }
        `}
          onClick={e => {
            e.stopPropagation();

            if (selected) return;

            // console.log({ mediaParentId });

            setCurrentBlock({ id });
          }}
        >
          {!selected && (
            // <i
            //   className="fas fa-code"
            //   css={css`
            //     font-size: 50px;
            //     color: rgba(0, 0, 0, 0.5);
            //   `}
            // />
            <img
              src={embedIcon}
              css={css`
                width: 50px;
              `}
            />
          )}

          {!selected && <EditMarker />}
        </div>
      </div>
    </div>
  );
};

export { EditWrapper0, EditWrapper1 };
